import { useTranslation } from "react-i18next";

import logo from "../../../../assets/BetwayScorePredict.png";
import closeIcon from "../../../../assets/close.png";
import goalBall from "../../../../assets/goal-ball.png";
import styles from "./InfoCard.module.css";

const InfoCard = ({ onClose, onButtonPress, onPrizesButtonPress }) => {
	const { t } = useTranslation();

	return (
		<div className={styles.container}>
			<img src={closeIcon} className={styles.closeButton} onClick={onClose} alt="close-icon" />
			<div className={styles.logoContainer}>
				<img src={logo} style={{ height: "21px", margin: "0 auto" }} alt="Welcome" />
			</div>
			<div className={styles.title}>{t("predictions.infoCard.title")}</div>
			<div className={styles.info}>{t("predictions.infoCard.description")}</div>
			<div>
				<img src={goalBall} className={styles.infoImage} alt="info-img" />
			</div>
			<div className={styles.buttonsWrapper}>
				<button className={styles.playButton} onClick={onButtonPress}>
					{t("predictions.infoCard.playButton")}
				</button>
				<button className={styles.rulesButton} onClick={onPrizesButtonPress}>
					{t("predictions.infoCard.prizesButton")}
				</button>
			</div>
		</div>
	);
};

export default InfoCard;
